module.exports = __webpack_public_path__ + "static/undraw_Work_time_re_hdyv-be3a343e473c404057bdb19e6665087e.svg";